import { cn } from "@/lib/utils";
import type { CSSProperties, HTMLAttributes } from "react";

export interface LoaderProps extends HTMLAttributes<HTMLDivElement> {
  size?: number;
  parentClassName?: string;
  stroke?: string;
  progress?: number;
}

export const Loader = ({
  size = 50,
  stroke = "#6B6397",
  className,
  parentClassName,
  progress,
  style,
  ...props
}: LoaderProps) => {
  const dotSize = Math.max(3, Math.round(size / 7));
  const resolvedParentClassName = parentClassName ?? (size <= 24 || className ? "" : "h-screen scale-300");
  const loaderStyle = {
    "--dot-color": stroke,
    "--loader-size": `${size}px`,
    "--dot-size": `${dotSize}px`,
    ...style,
  } as CSSProperties;

  return (
    <div className={cn("flex flex-col items-center justify-center gap-2", resolvedParentClassName)}>
      <div
        role="status"
        aria-label="Loading"
        {...props}
        className={cn("revelate-dot-loader", className)}
        style={loaderStyle}
      >
        <span className="revelate-dot-loader__dot" aria-hidden="true" />
        <span className="revelate-dot-loader__dot" aria-hidden="true" />
        <span className="revelate-dot-loader__dot" aria-hidden="true" />
        <span className="revelate-dot-loader__dot" aria-hidden="true" />
        <span className="revelate-dot-loader__travel" aria-hidden="true" />
      </div>
      {progress !== undefined && (
        <div className="text-sm text-muted-foreground">
          {Math.round(progress)}% complete
        </div>
      )}
    </div>
  );
};
